import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgExperience(props: RootSvgProps) {
  return (
    <RootSvg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_4628_55460)">
        <path
          d="M12 6V4.5H9V6H12ZM4.5 7.5V15.75H16.5V7.5H4.5ZM16.5 6C17.3325 6 18 6.6675 18 7.5V15.75C18 16.5825 17.3325 17.25 16.5 17.25H4.5C3.6675 17.25 3 16.5825 3 15.75L3.0075 7.5C3.0075 6.6675 3.6675 6 4.5 6H7.5V4.5C7.5 3.6675 8.1675 3 9 3H12C12.8325 3 13.5 3.6675 13.5 4.5V6H16.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4628_55460">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
